import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-flexbox-grid'
import { Colors } from '../../theme'
import Card from '@material-ui/core/Card'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import ProvidersDropdownMenu from '../../controls/ProvidersDropdownMenu'
import ProvidersSearchInput from '../../controls/ProvidersSearchInput'
import { radiusData, providerTypeData } from './providersDropdownData'

class Filter extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filters: {
        radius: 0,
        providerType: '',
        providerTypeSubcategory: '',
        address: ''
      },
      providerType: [],
      providerTypeSubcategory: [],
      radius: [],
      providerAddress: {},
      providerError: '',
      openModal: false,
      autocomplete: null,
      isSubcategory: false,
      subcategoryError: ''
    }
    this.handleLocationChange = this.handleLocationChange.bind(this)
    this.handleSearchClick = this.handleSearchClick.bind(this)
    this.handleClearSearchClick = this.handleClearSearchClick.bind(this)
    this.handleLatLngChange = this.handleLatLngChange.bind(this)
    this.updateFilters = this.updateFilters.bind(this)
    this.updateFiltersProviders = this.updateFiltersProviders.bind(this)
    this.updateFilterSubcategory = this.updateFilterSubcategory.bind(this)
  }

  updateFilters (valueObj) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        ...valueObj
      }
    }))
  }

  updateFiltersProviders (valueObj) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        ...valueObj
      }
    }))
    if (valueObj.providerType !== null && valueObj.providerType !== 'Drug') {
      const selectedProviderType = this.state.providerType.find(pt => pt.id === valueObj.providerType)
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          providerTypeSubcategory: ''
        },
        providerTypeSubcategory: selectedProviderType ? selectedProviderType.specialities : [],
        isSubcategory: true
      }))
    } else {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          providerTypeSubcategory: ''
        },
        providerTypeSubcategory: [],
        isSubcategory: false
      }))
    }
  }

  updateFilterSubcategory (valueObj) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        ...valueObj
      },
      subcategoryError: ''
    }))
  }

  handleLocationChange (value) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        address: value
      }
    }))
  }

  handleLatLngChange (address) {
    this.setState(prevState => ({
      ...prevState,
      providerAddress: {
        lat: address.lat,
        lng: address.lng
      }
    }))
  }

  handleSearchClick () {
    console.log('handleSearchClick', this.state.filters.providerTypeSubcategory)
    if (this.state.providerTypeSubcategory.length > 0 && (
      this.state.filters.providerTypeSubcategory === '' ||
      this.state.filters.providerTypeSubcategory === null)) {
      this.setState({ subcategoryError: localize('pages.providers.filter.providerTypeCategory.error') })
    } else {
      this.props.onProviderFilterSearch({
        lat: this.state.providerAddress.lat,
        lng: this.state.providerAddress.lng,
        filters: this.state.filters
      })
      this.setState({ subcategoryError: '' })
    }
  }

  handleClearSearchClick () {
    this.props.onProviderFilterSearch({
      filters: null
    })
  }

  prepareForDropdown (data) {
    return data
      .filter((item) => item.id !== 0)
      .map(item => ({ id: item.id, text: item.label, specialities: item.specialties }))
  }

  handleModalError = (error) => {
    this.setState(prevState => ({
      ...prevState,
      openModal: true,
      providerError: error
    }))
  }

  handleModalClose = () => {
    this.setState(prevState => ({
      ...prevState,
      openModal: false,
      providerError: ''
    }))
  }

  async fetchProviderTypeData () {
    const providerType = await providerTypeData()
    this.setState({ providerType: this.prepareForDropdown(providerType) })
  }

  componentDidMount () {
    this.fetchProviderTypeData()
    this.setState(prevState => ({
      ...prevState,
      radius: this.prepareForDropdown(radiusData),
      autocomplete: this.props.autocomplete
    }))
  }

  componentDidUpdate (prevProps) {
    if (this.props.providerError !== prevProps.providerError) {
      this.setState(prevState => ({
        ...prevState,
        openModal: true
      }))
    }
    if (this.props.autocomplete !== prevProps.autocomplete) {
      this.setState(prevState => ({
        ...prevState,
        autocomplete: this.props.autocomplete
      }))
    }
  }

  render () {
    const { classes = {} } = this.props

    return (
      <div className='filterProviders' id={'filterProviders'}>
        <Card id='filterProvidersCard' className={classes.baseCard}>
          <Grid fluid>
            <Row style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '15px' }}>
              <Col lg={this.state.isSubcategory ? 3 : 4} md={6} sm={12} xs={12} className='ieFilterCard searchInputContainer'>
                <ProvidersSearchInput
                  floatingLabelFixed
                  fullWidth
                  floatingLabelText={localize('pages.providers.filter.location.label')}
                  defaultText={localize('pages.providers.filter.location.placeholder')}
                  onChange={this.handleLocationChange}
                  sendValues={this.updateFilters}
                  errorHandler={this.handleModalError}
                  autocomplete={this.state.autocomplete}
                  handleLatLng={this.handleLatLngChange}/>
              </Col>
              <Col lg={2} md={2} sm={6} xs={12} className='ieFilterCard'>
                <ProvidersDropdownMenu
                  ref={(comp) => { this.statusDropdown = comp }}
                  fullWidth
                  data={this.state.providerType}
                  id='providerType'
                  defaultText={localize('pages.providers.filter.providerType.placeholder')}
                  label={localize('pages.providers.filter.providerType.label')}
                  selected={this.state.filters.providerType}
                  sendValues={this.updateFiltersProviders} />
              </Col>
              {this.state.isSubcategory && <Col lg={2} md={2} sm={6} xs={12} className='ieFilterCard'>
                <ProvidersDropdownMenu
                  ref={(comp) => { this.statusDropdown = comp }}
                  fullWidth
                  data={this.state.providerTypeSubcategory}
                  id='providerTypeSubcategory'
                  defaultText={localize('pages.providers.filter.providerTypeCategory.placeholder')}
                  label={localize('pages.providers.filter.providerTypeCategory.label')}
                  selected={this.state.filters.providerTypeSubcategory}
                  sendValues={this.updateFilterSubcategory}
                  errorText={this.state.subcategoryError}/>
              </Col>}
              <Col lg={1} md={2} sm={6} xs={12} className='ieFilterCard'>
                <ProvidersDropdownMenu
                  ref={(comp) => { this.statusDropdown = comp }}
                  fullWidth
                  data={this.state.radius}
                  id='radius'
                  label={localize('pages.providers.filter.radius.label')}
                  selected={this.state.filters.radius}
                  sendValues={this.updateFilters}
                  defaultValue={1000}/>
              </Col>
              <Col lg={3} md={6} sm={6} xs={12} className='ieFilterCard'>
                <Row className='providersSearchButtons'>
                  <RBButton
                    id='providersSearchButton'
                    className='searchButton'
                    label={localize('pages.providers.filter.button.search')}
                    onClick={this.handleSearchClick}
                    labelColor={Colors.primaryColor}
                    disabled={this.state.filters.address === ''}
                    variant='outlined' color />
                  <RBButton
                    id='providersSearchButton'
                    className='clearSearchButton'
                    label={localize('pages.providers.filter.button.clearSearch')}
                    onClick={this.handleClearSearchClick}
                    labelColor={Colors.primaryColor}
                    disabled={this.state.filters.address === ''}
                    color />
                </Row>
              </Col>
            </Row>
          </Grid>
        </Card>
        <Dialog
          onClose={this.handleModalClose}
          aria-labelledby="simple-dialog-title"
          open={this.state.openModal}
          disableBackdropClick={true}
        >

          <DialogContent>
            {this.state.providerError}
          </DialogContent>
          <DialogActions>
            <RBButton
              variant='outlined'
              key='close'
              label={localize('common.close')}
              primary={false}
              onClick={this.handleModalClose}
            />
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./src/widgets/Providers/Filter.js